module.exports = __webpack_public_path__ + "static/img/30.2617d744.png";